import { endOfMonth } from 'date-fns'
import { RevenueCardProps } from './types'
import { getTrendText } from './utils'
import { getTrendSymbol, getTrendColor } from '../common/utils'
import {
  formatPrice,
  formatToPercentage
} from '../../../../../../utils/format'
import {
  ProjectionLabel,
  ProjectionValue,
  ProjectionWrapper,
  TrendText
} from './styles'
import {
  CardContainer,
  CardTitle,
  TrendWrapper,
  ValueWrapper,
  StickyBottomWrapper
} from '../common/styles'

export const RevenueCard = ({
  value = 0,
  projectionValue = 0,
  lastYearPercentage,
}: RevenueCardProps) => {
  const trendColor = typeof lastYearPercentage === 'number'
    ? getTrendColor(lastYearPercentage)
    : ''

  const currentDate = new Date()
  const formattedDate = endOfMonth(currentDate).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })

  return (
    <CardContainer>
      <CardTitle>FATURAMENTO</CardTitle>

      <ValueWrapper>
        {formatPrice(value)}
      </ValueWrapper>

      <StickyBottomWrapper>
        {typeof lastYearPercentage === 'number' && (
          <TrendWrapper color={trendColor}>
            {getTrendSymbol(lastYearPercentage)}
            {' '}
            {formatToPercentage(Math.abs(lastYearPercentage))}
            <TrendText>{getTrendText(lastYearPercentage)}</TrendText>
          </TrendWrapper>
        )}

        <ProjectionWrapper>
          <ProjectionLabel>Previsão - para {formattedDate}</ProjectionLabel>
          <ProjectionValue>
            {formatPrice(projectionValue)}
          </ProjectionValue>
        </ProjectionWrapper>
      </StickyBottomWrapper>
    </CardContainer>
  )
}
